export const API = process.env.VUE_APP_API;
export const LANG = process.env.VUE_APP_I18N_LOCALE;
export const LANG_FALLBACK = process.env.VUE_APP_I18N_FALLBACK_LOCALE;
export const SAP_USERNAME = process.env.VUE_APP_SAP_USERNAME;
export const SAP_PASSWORD = process.env.VUE_APP_SAP_PASSWORK;
export const ENV = process.env.NODE_ENV;
